import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider, useUser } from './context/UserContext';

import Login          from './pages/Login';
import Register       from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard      from './pages/Dashboard';
import Profile        from './pages/Profile';
import Schedule       from './pages/Schedule';
import Material       from './pages/Material';
import Subscription   from './pages/Subscription';
import Search         from './pages/Search';
import About          from './pages/About';
import StageGate        from './pages/StageGate';
import StageGateBuilder from './pages/StageGateBuilder';
import AIUsage          from './pages/AIUsage';
import Analytics        from './pages/TutorAnalytics';
import VerifyEmail      from './pages/VerifyEmail';
import AdminSubjects    from './pages/AdminSubjects';
import AdminTemplates   from './pages/AdminTemplates';
import AdminFeedback    from './pages/AdminFeedback';
import AdminUsers       from './pages/AdminUsers';

function RequireAuth({ children }) {
  const { user } = useUser();
  return user ? children : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <Routes>
          <Route path="/"                element={<Login />} />
          <Route path="/register"        element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-email"    element={<VerifyEmail />} />
          <Route path="/tutor/:id"       element={<Profile />} />
          <Route path="/about"           element={<RequireAuth><About /></RequireAuth>} />
          <Route path="/dashboard"       element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/profile"         element={<RequireAuth><Profile /></RequireAuth>} />
          <Route path="/schedule"        element={<RequireAuth><Schedule /></RequireAuth>} />
          <Route path="/material"        element={<RequireAuth><Material /></RequireAuth>} />
          <Route path="/subscription"    element={<RequireAuth><Subscription /></RequireAuth>} />
          <Route path="/search"          element={<RequireAuth><Search /></RequireAuth>} />
          <Route path="/stage-gate"         element={<RequireAuth><StageGate /></RequireAuth>} />
          <Route path="/stage-gate/builder" element={<RequireAuth><StageGateBuilder /></RequireAuth>} />
          <Route path="/ai-usage"           element={<RequireAuth><AIUsage /></RequireAuth>} />
          <Route path="/analytics"          element={<RequireAuth><Analytics /></RequireAuth>} />
          <Route path="/admin/subjects"     element={<RequireAuth><AdminSubjects /></RequireAuth>} />
          <Route path="/admin/templates"    element={<RequireAuth><AdminTemplates /></RequireAuth>} />
          <Route path="/admin/feedback"     element={<RequireAuth><AdminFeedback /></RequireAuth>} />
          <Route path="/admin/users"        element={<RequireAuth><AdminUsers /></RequireAuth>} />
        </Routes>
      </UserProvider>
    </BrowserRouter>
  );
}
